import { createAction, props } from '@ngrx/store';

import { GoodsReceiveExportCriteria } from '@shared/models/goods-receive.model';
import { ProfitSharingExportCriteria } from '@shared/models/profit-sharing.model';
import { PurchaseOrderExportCriteria } from '@shared/models/purchase-order.model';
import { PurchaseRequestExportCriteria } from '@shared/models/purchase-request.model';
import { RewardCatalogExportCriteria } from '@shared/models/reward-catalog.model';
import { StockTransferGRExportCriteria } from '@shared/models/stock-transfer-gr.model';
import { SupplierExportCriteria } from '@shared/models/supplier.model';

import { ClaimRequestExportCriteria } from '../../../../pages/claim-request/model/claim-request.model';
import { ExportAdjustCriteria } from '../../../../pages/manage-stock/models/adjust-stock.model';
import {
  OnlineCouponExportCriteria,
  OnlineCouponSummaryCriteria
} from '../../../../pages/online-coupon/model/online-coupon.model';
import { RewardExportCriteria } from '../../../../pages/reward/models/reward.model';
import { ExportStoreAssortmentByProductCriteria } from '../../../../pages/store-assortment/models/store-assortment-request-store.model';
import { StoreConsultantExportCriteria } from '../../../../pages/store-consultant/models/store-consultant.model';
import { ExportFileTypeEnum } from '../../../enum/export-file-type.enum';
import {
  ExportAssortmentSearchCriteria,
  ExportStockByLocationCriteria,
  ExportStockByProductCriteria,
  ShipmentExportCriteria,
  StoreExportCriteria,
  StoreExportOrderScheduleCriteria
} from '../../../models';
import { DeliveryOrderExportPickingCriteria } from '../../../models/delivery-order.model';
import { OrderExportCriteria } from '../../../models/order.model';
import { HoldAssortmentReportCriteria } from '../../../models/permanent-hold.model';
import { ReceiveOrderExportCriteria } from '../../../models/receive-order.model';
import {
  AgentPaymentTransactionReportCriteria,
  AwaitingAllocationForGroupOrderReportCriteria,
  AwaitingFirstLotExportCriteria,
  BillPaymentTransactionReportCriteria,
  CJXMemberRewardTransactionCriteria,
  CJXSalesSummaryReportCriteria,
  CJXSalesTransactionReportCriteria,
  CJXVoucherExportCriteria,
  CafeBillOfMaterialsCostReportCriteria,
  CafeOrderProcessingPerformanceReportCriteria,
  CafeSalesAndProfitReportCriteria,
  CashCountingReportCriteria,
  CashSettlementTransactionReportCriteria,
  CheckProductTagCriteria,
  CollectExpiredPromotionTagCriteria,
  CountItemInToteReportCriteria,
  CrossDockInvoiceReportCriteria,
  CustomerSatisfactionSurveyReportCriteria,
  DcAssortmentExportCriteria,
  DestroyDocumentReportCriteria,
  DestroyTransactionExportReportCriteria,
  DestroyTransactionReportExportCriteria,
  DispatchToteReportCriteria,
  EdcPaymentTransactionReportCriteria,
  FlashSaleOrderReportCriteria,
  GiftWithPurchaseReportCriteria,
  GiftWithPurchaseTransactionReportCriteria,
  GroupOrderUnpickedItemReportCriteria,
  HoldOrderReportCriteria,
  InventoryAdjustmentRequestReportExportCriteria,
  InventoryCountTransactionReportExportCriteria,
  InventoryCountTransactionTempReportExportCriteria,
  InventoryVarianceCriteria,
  LinemanOrderMissingReceiptReportCriteria,
  LinemanProductCriteria,
  LinemanSalesReconcileTransactionReportCriteria,
  LoadingGroupByWarehouseCriteria,
  ManualChangeDeliveryStatusReportCriteria,
  MaterialRequestTransactionCriteria,
  MemberProfileReportCriteria,
  MemberRewardTransactionCriteria,
  MobilePhoneSaleAndRefundReportCriteria,
  MoneyInOutReportCriteria,
  MoneyInReportCriteria,
  OnlineCouponCompensateCriteria,
  OnlineCouponTransactionCriteria,
  OrderProcessingHoldCriteria,
  PointActivityReportCriteria,
  PointBurnTransactionReportCriteria,
  PointEarnTransactionReportCriteria,
  PreOrderCompensateReportCriteria,
  PreOrderCreditRemainingReportCriteria,
  PreOrderTransactionReportCriteria,
  ProductEcommerceReportCriteria,
  ProductReportExportCriteria,
  ProductRetailPriceConfidentialReportCriteria,
  PromotionCompensateReportExportCriteria,
  PromotionReportCriteria,
  PromotionTransactionReportCriteria,
  PromotionV2ReportCriteria,
  QRPaymentTransactionReportCriteria,
  RecallCreditNoteReportCriteria,
  RecallStockCheckConfirmationReportCriteria,
  RecallStockPackingConfirmationReportCriteria,
  ReceiptCouponTransactionReportCriteria,
  ReceiveOrderExceedReportCriteria,
  ReceiveToteReportCriteria,
  RedeemTransactionReportCriteria,
  ReduceToClearSummaryReportCriteria,
  ReduceToClearTransactionReportCriteria,
  RefundExceptionTransactionReportCriteria,
  RefundExportCriteria,
  ResponseReportCriteria,
  ReturnToSupplierReportCriteria,
  ReturnToWarehouseChargeReportCriteria,
  ReturnToWarehouseGRReportCriteria,
  ReturnToWarehouseOrderReportCriteria,
  ReturnToteReportCriteria,
  RewardTransactionReportCriteria,
  SalePerformanceReportCriteria,
  SalesSummaryReportExportCriteria,
  SalesTaxReportCriteria,
  SalesTransactionExportCriteria,
  ShelfInventoryReportCriteria,
  ShelfReplenishmentPhotoReviewCriteria,
  ShelfReplenishmentSummaryReportCriteria,
  ShelfReplenishmentTransactionReportCriteria,
  ShiftRecordReportCriteria,
  SpecialPointCompensateReportCriteria,
  SpecialPointReportCriteria,
  StockCardExportCriteria,
  StockCountAssignmentSummaryReportCriteria,
  StockCountAssignmentTransactionReportCriteria,
  StockCountByQISummaryDailyReportCriteria,
  StockCountByQISummaryReportCriteria,
  StockCountByQITransactionReportCriteria,
  StockCountByStaffTransactionReportCriteria,
  StockRefillPerformanceCriteria,
  StockRefillSummaryCriteria,
  StoreApprovalBypassReportCriteria,
  StoreAvailableAdjustmentRequestReportCriteria,
  StoreExpenseReportCriteria,
  StoreGroupExportCriteria,
  StoreLocationByDcReportCriteria,
  StoreOtherIncomeReportCriteria,
  StoreStockRecallReportCriteria,
  StoreToteFineReportCriteria,
  StoreToteReportCriteria,
  SupplierCouponReconcileReportExportCriteria,
  SupplierCouponTransactionExportCriteria,
  SupplierPartnerCouponCriteria,
  SurveyReportCriteria,
  TaskAssignmentReportCriteria,
  ToteAdjustmentReportCriteria,
  UserReportCriteria,
  VoucherCriteria
} from '../../../models/report.model';
import { StockTransferExportCriteria } from '../../../models/stock-transfer.model';

export const dynamicReportAction = {
  // export report actions
  moneyIn: createAction('[Dynamic Report] Money In Report', props<{ payload: MoneyInReportCriteria }>()),
  toteAdjustment: createAction(
    '[Dynamic Report] Tote Adjustment',
    props<{ payload: ToteAdjustmentReportCriteria }>()
  ),
  holdAssortment: createAction('[Dynamic Report] Permanent Hold', props<{ payload: HoldAssortmentReportCriteria }>()),
  groupOrderUnpickedItem: createAction(
    '[Dynamic Report] Group Order Unpicked Item ',
    props<{ payload: GroupOrderUnpickedItemReportCriteria }>()
  ),
  awaitingAllocationForGroupOrder: createAction(
    '[Dynamic Report] Awaiting Allocation For Group Order',
    props<{ payload: AwaitingAllocationForGroupOrderReportCriteria }>()
  ),
  memberRewardTransactions: createAction(
    '[Dynamic Report] Member Reward Transactions',
    props<{ payload: MemberRewardTransactionCriteria }>()
  ),
  memberRewardTransactionsWithPrice: createAction(
    '[Dynamic Report] Member Reward Transactions With Price',
    props<{ payload: MemberRewardTransactionCriteria }>()
  ),
  cjxMemberRewardTransactions: createAction(
    '[Dynamic Report] CJX Member Reward Transactions',
    props<{ payload: CJXMemberRewardTransactionCriteria }>()
  ),
  billPayment: createAction('[Dynamic Report] Bill Payment', props<{ payload: any }>()),
  orderProcessingHold: createAction(
    '[Dynamic Report] Order Processing Hold',
    props<{ payload: OrderProcessingHoldCriteria }>()
  ),
  receiveOrderExceed: createAction(
    '[Dynamic Report] Receive Order Exceed',
    props<{ payload: ReceiveOrderExceedReportCriteria }>()
  ),
  redeemTransaction: createAction(
    '[Dynamic Report] Redeem Transaction',
    props<{ payload: RedeemTransactionReportCriteria }>()
  ),
  rewardTransaction: createAction(
    '[Dynamic Report] Reward Transaction',
    props<{ payload: RewardTransactionReportCriteria }>()
  ),
  preOrderCompensate: createAction(
    '[Dynamic Report] Pre Order Compensate',
    props<{ payload: PreOrderCompensateReportCriteria }>()
  ),
  promotionCompensate: createAction(
    '[Dynamic Report] Promotion Compensate',
    props<{ payload: PromotionCompensateReportExportCriteria }>()
  ),
  salesSummary: createAction(
    '[Dynamic Report] Sales Summary',
    props<{ payload: SalesSummaryReportExportCriteria }>()
  ),
  salesTransaction: createAction(
    '[Dynamic Report] Sales Transaction',
    props<{ payload: SalesTransactionExportCriteria }>()
  ),
  supplierCouponReconcile: createAction(
    '[Dynamic Report] Supplier Coupon Reconcile',
    props<{ payload: SupplierCouponReconcileReportExportCriteria }>()
  ),
  voucher: createAction('[Dynamic Report] Voucher', props<{ payload: VoucherCriteria }>()),
  cjxVoucher: createAction('[Dynamic Report] CJX Voucher', props<{ payload: CJXVoucherExportCriteria }>()),
  inventoryAdjustmentRequest: createAction(
    '[Dynamic Report] Inventory Adjustment Request',
    props<{ payload: InventoryAdjustmentRequestReportExportCriteria }>()
  ),
  destroyDocument: createAction(
    '[Dynamic Report] Destroy Document',
    props<{ payload: DestroyDocumentReportCriteria }>()
  ),
  inventoryVariance: createAction(
    '[Dynamic Report] Inventory Variance',
    props<{ payload: InventoryVarianceCriteria }>()
  ),
  destroyTransaction: createAction(
    '[Dynamic Report] Destroy Transaction',
    props<{ payload: DestroyTransactionReportExportCriteria }>()
  ),
  inventoryCountTransactions: createAction(
    '[Dynamic Report] Inventory Count Transaction',
    props<{ payload: InventoryCountTransactionReportExportCriteria }>()
  ),
  inventoryCountTransactionsWithPrice: createAction(
    '[Dynamic Report] Inventory Count Transaction With Price',
    props<{ payload: InventoryCountTransactionTempReportExportCriteria }>()
  ),
  preOrderTransaction: createAction(
    '[Dynamic Report] Pre Order Transaction',
    props<{ payload: PreOrderTransactionReportCriteria }>()
  ),
  preOrderTransactionWithPrice: createAction(
    '[Dynamic Report] Pre Order Transaction With Price',
    props<{ payload: PreOrderTransactionReportCriteria }>()
  ),
  promotion: createAction('[Dynamic Report] Promotion', props<{ payload: PromotionReportCriteria }>()),
  specialPointCompensate: createAction(
    '[Dynamic Report] Special Point Compensate',
    props<{ payload: SpecialPointCompensateReportCriteria }>()
  ),
  specialPoint: createAction('[Dynamic Report] Special Point', props<{ payload: SpecialPointReportCriteria }>()),
  shipment: createAction('[Dynamic Report] Shipment', props<{ payload: ShipmentExportCriteria }>()),
  response: createAction('[Dynamic Report] Response', props<{ payload: ResponseReportCriteria }>()),
  survey: createAction('[Dynamic Report] Survey', props<{ payload: SurveyReportCriteria }>()),
  returnToWarehouseOrder: createAction(
    '[Dynamic Report] Return To Warehouse Order',
    props<{ payload: ReturnToWarehouseOrderReportCriteria }>()
  ),
  returnToWarehouseGR: createAction(
    '[Dynamic Report] Return To Warehouse GR',
    props<{ payload: ReturnToWarehouseGRReportCriteria }>()
  ),
  returnToWarehouseCharge: createAction(
    '[Dynamic Report] Return To Warehouse Charge',
    props<{ payload: ReturnToWarehouseChargeReportCriteria }>()
  ),
  flashSaleOrder: createAction(
    '[Dynamic Report] Flash Sale Order',
    props<{ payload: FlashSaleOrderReportCriteria }>()
  ),
  onlineCouponTransaction: createAction(
    '[Dynamic Report] Online Coupon Transaction',
    props<{ payload: OnlineCouponTransactionCriteria }>()
  ),
  onlineCouponCompensate: createAction(
    '[Dynamic Report] Online Coupon Compensate',
    props<{ payload: OnlineCouponCompensateCriteria }>()
  ),
  taskAssignment: createAction(
    '[Dynamic Report] Task Assignment',
    props<{ payload: TaskAssignmentReportCriteria }>()
  ),
  order: createAction('[Dynamic Report] Order', props<{ payload: OrderExportCriteria }>()),
  salesTransactionConfidential: createAction(
    '[Dynamic Report] Sales Transaction Confidential',
    props<{ payload: SalesTransactionExportCriteria }>()
  ),
  refundSummary: createAction('[Dynamic Report] Refund Summary', props<{ payload: RefundExportCriteria }>()),
  refundTransaction: createAction('[Dynamic Report] Refund Transaction', props<{ payload: RefundExportCriteria }>()),
  deliveryOrder: createAction(
    '[Dynamic Report] Delivery Order',
    props<{ payload: DeliveryOrderExportPickingCriteria }>()
  ),
  receiveOrder: createAction('[Dynamic Report] Receive Order', props<{ payload: ReceiveOrderExportCriteria }>()),
  claim: createAction('[Dynamic Report] Claim', props<{ payload: ClaimRequestExportCriteria }>()),
  awaitingFirstLot: createAction(
    '[Dynamic Report] Awaiting First Lot',
    props<{ payload: AwaitingFirstLotExportCriteria }>()
  ),
  stockByProduct: createAction(
    '[Dynamic Report] Stock By Product',
    props<{ payload: ExportStockByProductCriteria }>()
  ),
  stockAdjustment: createAction('[Dynamic Report] Stock Adjustment', props<{ payload: ExportAdjustCriteria }>()),
  stockCard: createAction('[Dynamic Report] Stock Card', props<{ payload: StockCardExportCriteria }>()),
  transferOrder: createAction('[Dynamic Report] Transfer Order', props<{ payload: StockTransferExportCriteria }>()),
  transferGoodsReceive: createAction(
    '[Dynamic Report] Transfer Goods Receive',
    props<{ payload: StockTransferGRExportCriteria }>()
  ),
  user: createAction('[Dynamic Report] User', props<{ payload: UserReportCriteria }>()),
  profitSharing: createAction('[Dynamic Report] Profit Sharing', props<{ payload: ProfitSharingExportCriteria }>()),
  storeConsultant: createAction(
    '[Dynamic Report] Store Consultant',
    props<{ payload: StoreConsultantExportCriteria }>()
  ),
  store: createAction('[Dynamic Report] Store', props<{ payload: StoreExportCriteria }>()),
  storeConfidential: createAction('[Dynamic Report] Store Confidential', props<{ payload: StoreExportCriteria }>()),
  storeOrderSchedule: createAction(
    '[Dynamic Report] Store Order Schedule',
    props<{ payload: StoreExportOrderScheduleCriteria }>()
  ),
  storeLocationByDc: createAction(
    '[Dynamic Report] Store Location By DC',
    props<{ payload: StoreLocationByDcReportCriteria }>()
  ),
  companyAssortment: createAction(
    '[Dynamic Report] Company Assortment',
    props<{ payload: ExportAssortmentSearchCriteria }>()
  ),
  companyAssortmentConfidential: createAction(
    '[Dynamic Report] Company Assortment Confidential',
    props<{ payload: ExportAssortmentSearchCriteria }>()
  ),
  productByLocation: createAction(
    '[Dynamic Report] Product By Location',
    props<{ payload: ExportStoreAssortmentByProductCriteria }>()
  ),
  dcAssortment: createAction('[Dynamic Report] DC Assortment', props<{ payload: DcAssortmentExportCriteria }>()),
  movingAverage: createAction('[Dynamic Report] Moving Average', props<{ payload: any }>()),
  preOrderCatalog: createAction('[Dynamic Report] Pre Order Catalog', props<{ payload: any }>()),
  preOrderCatalogConfidential: createAction(
    '[Dynamic Report] Pre Order Catalog Confidential',
    props<{ payload: any }>()
  ),
  shelfFixAsset: createAction('[Dynamic Report] Shelf Fix Asset', props<{ payload: any }>()),
  shelfInventory: createAction(
    '[Dynamic Report] Shelf Inventory',
    props<{ payload: ShelfInventoryReportCriteria }>()
  ),
  storeAssortment: createAction('[Dynamic Report] Store Assortment', props<{ payload: any }>()),
  holdOrder: createAction('[Dynamic Report] Hold Order', props<{ payload: HoldOrderReportCriteria }>()),
  reward: createAction('[Dynamic Report] Reward', props<{ payload: RewardExportCriteria }>()),
  pointEarnTransaction: createAction(
    '[Dynamic Report] Point Earn Transaction',
    props<{ payload: PointEarnTransactionReportCriteria }>()
  ),
  pointBurnTransaction: createAction(
    '[Dynamic Report] Point Burn Transaction',
    props<{ payload: PointBurnTransactionReportCriteria }>()
  ),
  onlineCoupon: createAction('[Dynamic Report] Online Coupon', props<{ payload: OnlineCouponExportCriteria }>()),
  onlineCouponSummary: createAction(
    '[Dynamic Report] Online Coupon Summary',
    props<{ payload: OnlineCouponSummaryCriteria }>()
  ),
  memberRewardCatalog: createAction(
    '[Dynamic Report] Member Reward Catalog',
    props<{ payload: RewardCatalogExportCriteria }>()
  ),
  stockByLocation: createAction(
    '[Dynamic Report] Stock By Location',
    props<{ payload: ExportStockByLocationCriteria }>()
  ),
  purchaseRequest: createAction(
    '[Dynamic Report] Purchase Request',
    props<{ payload: PurchaseRequestExportCriteria }>()
  ),
  purchaseOrder: createAction('[Dynamic Report] Purchase Order', props<{ payload: PurchaseOrderExportCriteria }>()),
  goodsReceive: createAction('[Dynamic Report] Goods Receive', props<{ payload: GoodsReceiveExportCriteria }>()),
  preOrderCreditRemaining: createAction(
    '[Dynamic Report] Pre Order Credit Remaining',
    props<{ payload: PreOrderCreditRemainingReportCriteria }>()
  ),
  storeApprovalBypass: createAction(
    '[Dynamic Report] Store Approval Bypass',
    props<{ payload: StoreApprovalBypassReportCriteria }>()
  ),

  crossDockInvoice: createAction(
    '[Dynamic Report] Cross Dock Invoice',
    props<{ payload: CrossDockInvoiceReportCriteria }>()
  ),
  storeTote: createAction('[Dynamic Report] Store Tote', props<{ payload: StoreToteReportCriteria }>()),
  storeToteFine: createAction('[Dynamic Report] Store Tote Fine', props<{ payload: StoreToteFineReportCriteria }>()),
  manualChangeDeliveryStatus: createAction(
    '[Dynamic Report] Manual Change Delivery Status',
    props<{ payload: ManualChangeDeliveryStatusReportCriteria }>()
  ),
  clearAllStates: createAction('[Dynamic Report] Clear States'),
  // handle response(file, message), error
  exportReportResponse: createAction(
    '[Dynamic Report] Export Report Response',
    props<{ isSuccess: boolean; response: any }>()
  ),
  exportReportFileResponse: createAction(
    '[Dynamic Report] Export Report File Response',
    props<{ isSuccess: boolean; response: any; fileName: string; extension?: ExportFileTypeEnum }>()
  ),
  exportReportError: createAction(
    '[Dynamic Report] Export Report Error',
    props<{ isSuccess: boolean; error: any }>()
  ),
  exportReportFileError: createAction(
    '[Dynamic Report] Export File Report Error',
    props<{ isSuccess: boolean; error: any }>()
  ),
  promotionV2: createAction(
    '[Dynamic Report] Export Promotion V2 report',
    props<{ payload: PromotionV2ReportCriteria }>()
  ),
  exportReportReduceToClearSummary: createAction(
    '[Dynamic Report] Export File Reduce to Clear Summary report',
    props<{ payload: ReduceToClearSummaryReportCriteria }>()
  ),
  exportReportDestroyTransaction: createAction(
    '[Dynamic Report] Export File Destroy Transaction report',
    props<{ payload: DestroyTransactionExportReportCriteria }>()
  ),
  exportReduceToClearTransaction: createAction(
    '[Dynamic Report] Export File Reduce to Clear Transaction report',
    props<{ payload: ReduceToClearTransactionReportCriteria }>()
  ),
  exportPromotionTransaction: createAction(
    '[Dynamic Report] Export Promotion Transaction report',
    props<{ payload: PromotionTransactionReportCriteria }>()
  ),
  cjxSalesTransaction: createAction(
    '[Dynamic Report] CJX Sales Transaction',
    props<{ payload: CJXSalesTransactionReportCriteria }>()
  ),
  materialRequestTransaction: createAction(
    '[Dynamic Report] Export Material Request Transaction report',
    props<{ payload: MaterialRequestTransactionCriteria }>()
  ),
  cashSettlementTransactionBeforeGoLive: createAction(
    '[Dynamic Report] Cash Settlement Transaction Before Go Live report',
    props<{ payload: CashSettlementTransactionReportCriteria }>()
  ),
  cashSettlementTransaction: createAction(
    '[Dynamic Report] Cash Settlement Transaction report',
    props<{ payload: CashSettlementTransactionReportCriteria }>()
  ),
  cashCounting: createAction(
    '[Dynamic Report] Cash Counting report',
    props<{ payload: CashCountingReportCriteria }>()
  ),
  supplier: createAction('[Dynamic Report] Supplier', props<{ payload: SupplierExportCriteria }>()),
  receiptCoupon: createAction(
    '[Dynamic Report] Receipt Coupon Transaction ',
    props<{ payload: ReceiptCouponTransactionReportCriteria }>()
  ),
  stockCountByQISummary: createAction(
    '[Dynamic Report] Stock Count by QI Summary',
    props<{ payload: StockCountByQISummaryReportCriteria }>()
  ),
  stockCountByQITransaction: createAction(
    '[Dynamic Report] Stock Count by QI Transaction',
    props<{ payload: StockCountByQITransactionReportCriteria }>()
  ),
  storeAvailableAdjustmentRequest: createAction(
    '[Dynamic Report] Store Available Adjustment Request',
    props<{ payload: StoreAvailableAdjustmentRequestReportCriteria }>()
  ),
  stockCountAssignmentSummary: createAction(
    '[Dynamic Report] Stock Count Assignment Summary',
    props<{ payload: StockCountAssignmentSummaryReportCriteria }>()
  ),
  stockCountAssignmentTransaction: createAction(
    '[Dynamic Report] Stock Count Assignment Transaction',
    props<{ payload: StockCountAssignmentTransactionReportCriteria }>()
  ),
  stockCountByStaffTransaction: createAction(
    '[Dynamic Report] Stock Count By Staff Transaction',
    props<{ payload: StockCountByStaffTransactionReportCriteria }>()
  ),
  stockCountByQIDailySummary: createAction(
    '[Dynamic Report] Stock Count by QI Daily Summary',
    props<{ payload: StockCountByQISummaryDailyReportCriteria }>()
  ),
  storeExpense: createAction('[Dynamic Report] Store Expense', props<{ payload: StoreExpenseReportCriteria }>()),
  storeOtherIncome: createAction(
    '[Dynamic Report] Store Other Income',
    props<{ payload: StoreOtherIncomeReportCriteria }>()
  ),
  salePerformance: createAction(
    '[Dynamic Report] Sale Performance',
    props<{ payload: SalePerformanceReportCriteria }>()
  ),
  countItemInTote: createAction(
    '[Dynamic Report] Count Item in Tote',
    props<{ payload: CountItemInToteReportCriteria }>()
  ),
  shiftRecord: createAction('[Dynamic Report] Shift Record', props<{ payload: ShiftRecordReportCriteria }>()),
  moneyInOut: createAction('[Dynamic Report] Money In-Out', props<{ payload: MoneyInOutReportCriteria }>()),
  cjxSalesSummary: createAction(
    '[Dynamic Report] CJX Sales Summary',
    props<{ payload: CJXSalesSummaryReportCriteria }>()
  ),
  supplierCouponIssueTransaction: createAction(
    '[Dynamic Report] Supplier Coupon Issue Transaction report',
    props<{ payload: SupplierCouponTransactionExportCriteria }>()
  ),
  supplierCouponTransaction: createAction(
    '[Dynamic Report] Supplier Coupon Transaction report',
    props<{ payload: SupplierCouponTransactionExportCriteria }>()
  ),
  cafeBillOfMaterialsCost: createAction(
    '[Dynamic Report] Cafe Bill of Materials Cost',
    props<{ payload: CafeBillOfMaterialsCostReportCriteria }>()
  ),
  cafeSalesAndProfit: createAction(
    '[Dynamic Report] Cafe Sales And Profit',
    props<{ payload: CafeSalesAndProfitReportCriteria }>()
  ),
  salesTax: createAction('[Dynamic Report] Sales Tax', props<{ payload: SalesTaxReportCriteria }>()),
  memberProfile: createAction(
    '[Dynamic Report] Member Profile report',
    props<{ payload: MemberProfileReportCriteria }>()
  ),
  pointActivity: createAction(
    '[Dynamic Report] Point Activity report',
    props<{ payload: PointActivityReportCriteria }>()
  ),
  cjxShelfInventory: createAction(
    '[Dynamic Report] CJX Shelf Inventory',
    props<{ payload: ShelfInventoryReportCriteria }>()
  ),
  giftWithPurchase: createAction(
    '[Dynamic Report] Gift with Purchase',
    props<{ payload: GiftWithPurchaseReportCriteria }>()
  ),
  giftWithPurchaseTransaction: createAction(
    '[Dynamic Report] Gift with Purchase Transaction',
    props<{ payload: GiftWithPurchaseTransactionReportCriteria }>()
  ),
  storeStockRecall: createAction(
    '[Dynamic Report] Store Stock Recall',
    props<{ payload: StoreStockRecallReportCriteria }>()
  ),
  recallStockPackingConfirmation: createAction(
    '[Dynamic Report] Recall Stock Packing Confirmation',
    props<{ payload: RecallStockPackingConfirmationReportCriteria }>()
  ),
  stockRefillSummary: createAction(
    '[Dynamic Report] Stock Refill Summary',
    props<{ payload: StockRefillSummaryCriteria }>()
  ),
  stockRefillPerformance: createAction(
    '[Dynamic Report] Stock Refill Performance',
    props<{ payload: StockRefillPerformanceCriteria }>()
  ),
  cafeOrderProcessingPerformance: createAction(
    '[Dynamic Report] CafeOrder Processing Performance Report',
    props<{ payload: CafeOrderProcessingPerformanceReportCriteria }>()
  ),
  recallStockCheckConfirmation: createAction(
    '[Dynamic Report] Recall Stock Check Confirmation',
    props<{ payload: RecallStockCheckConfirmationReportCriteria }>()
  ),
  recallCreditNote: createAction(
    '[Dynamic Report] Recall Credit Note',
    props<{ payload: RecallCreditNoteReportCriteria }>()
  ),
  qrPaymentTransaction: createAction(
    '[Dynamic Report] QR Payment Transaction Report',
    props<{ payload: QRPaymentTransactionReportCriteria }>()
  ),
  loadingGroupByWarehouse: createAction(
    '[Dynamic Report] Loading Group By Warehouse',
    props<{ payload: LoadingGroupByWarehouseCriteria }>()
  ),
  dispatchTote: createAction('[Dynamic Report] Dispatch Tote', props<{ payload: DispatchToteReportCriteria }>()),
  receiveTote: createAction('[Dynamic Report] Receive Tote', props<{ payload: ReceiveToteReportCriteria }>()),
  returnTote: createAction('[Dynamic Report] Return Tote', props<{ payload: ReturnToteReportCriteria }>()),
  shelfReplenishmentSummary: createAction(
    '[Dynamic Report] Shelf Replenishment Summary',
    props<{ payload: ShelfReplenishmentSummaryReportCriteria }>()
  ),
  shelfReplenishmentTransaction: createAction(
    '[Dynamic Report] Shelf Replenishment Transaction',
    props<{ payload: ShelfReplenishmentTransactionReportCriteria }>()
  ),
  shelfReplenishmentPhotoReviewAction: createAction(
    '[Dynamic Report] Shelf replenishment photo review',
    props<{ payload: ShelfReplenishmentPhotoReviewCriteria }>()
  ),
  checkProductTag: createAction('[Dynamic Report] Check Product Tag', props<{ payload: CheckProductTagCriteria }>()),
  collectExpiredPromotionTag: createAction(
    '[Dynamic Report] Collect Expired Promotion Tag',
    props<{ payload: CollectExpiredPromotionTagCriteria }>()
  ),
  storeGroup: createAction('[Dynamic Report] Store Group', props<{ payload: StoreGroupExportCriteria }>()),
  billPaymentTransaction: createAction(
    '[Dynamic Report] Bill Payment Transaction Report',
    props<{ payload: BillPaymentTransactionReportCriteria }>()
  ),
  supplierPartnerCoupon: createAction(
    '[Dynamic Report] Supplier Partner Coupon',
    props<{ payload: SupplierPartnerCouponCriteria }>()
  ),
  linemanProduct: createAction('[Dynamic Report] Lineman Product', props<{ payload: LinemanProductCriteria }>()),
  linemanSalesReconcileTransaction: createAction(
    '[Dynamic Report] Lineman Sales Reconcile Transaction Report',
    props<{ payload: LinemanSalesReconcileTransactionReportCriteria }>()
  ),
  linemanOrderMissingReceipt: createAction(
    '[Dynamic Report] Lineman Order Missing Receipt Report',
    props<{ payload: LinemanOrderMissingReceiptReportCriteria }>()
  ),
  agentPaymentTransactionReport: createAction(
    '[Dynamic Report] Agent Payment Transaction Report',
    props<{ payload: AgentPaymentTransactionReportCriteria }>()
  ),
  mobilePhoneSaleAndRefund: createAction(
    '[Dynamic Report] Mobile Phone Sales and Refund Report',
    props<{ payload: MobilePhoneSaleAndRefundReportCriteria }>()
  ),
  edcPaymentTransaction: createAction(
    '[Dynamic Report] EDC Payment Transaction Report',
    props<{ payload: EdcPaymentTransactionReportCriteria }>()
  ),
  refundExceptionTransaction: createAction(
    '[Dynamic Report] Refund Exception Transaction Report',
    props<{ payload: RefundExceptionTransactionReportCriteria }>()
  ),
  returnToSupplier: createAction(
    '[Dynamic Report] Return to Supplier Report',
    props<{ payload: ReturnToSupplierReportCriteria }>()
  ),
  customerSatisfactionSurvey: createAction(
    '[Dynamic Report] Customer Satisfaction Survey Report',
    props<{ payload: CustomerSatisfactionSurveyReportCriteria }>()
  ),
  product: createAction('[Dynamic Report] Product', props<{ payload: ProductReportExportCriteria }>()),
  productConfidential: createAction(
    '[Dynamic Report] Product Confidential Report',
    props<{ payload: ProductReportExportCriteria }>()
  ),
  productRetailPriceConfidential: createAction(
    '[Dynamic Report] Product Retail Price Confidential Report',
    props<{ payload: ProductRetailPriceConfidentialReportCriteria }>()
  ),
  productEcommerce: createAction(
    '[Dynamic Report] Product Ecommerce Report',
    props<{ payload: ProductEcommerceReportCriteria }>()
  )
};
